import React, { createContext, Dispatch, SetStateAction, useState, useContext, useCallback, useMemo } from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

interface IProps {
  children: JSX.Element;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }),
);

export const BackdropContextComponent = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const [open, setOpen] = useState<boolean>(false);
  return (
    <BackdropContext.Provider value={setOpen}>
      {props.children}
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </BackdropContext.Provider>
  );
};

const BackdropContext = createContext<Dispatch<SetStateAction<boolean>>>(() => undefined);

const useBackdrop = () => {
  const backdropContext = useContext(BackdropContext);

  const show = useCallback(() => {
    backdropContext(true);
  }, [backdropContext]);

  const hide = useCallback(() => {
    backdropContext(false);
  }, [backdropContext]);

  return useMemo(() => ({ show, hide }), [show, hide]);
};

export default useBackdrop;
